module.exports = __webpack_public_path__ + "img/nutritionAvatar.3b2a0cdd.jpeg";